export class NavigationUtils {

    static navigateToProductDetailsOrProductsList(hasVisitedProductDetailsPage, lastVisitedProduct, selectedCategory = "") {
        if(hasVisitedProductDetailsPage && lastVisitedProduct.product_id) {
            return "/itemdetails/"+lastVisitedProduct.product_id;
        } else {
            return "/items/"+(selectedCategory !== '' ? selectedCategory : '');
        }
    }
}